import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, BUSINESS } from "@/data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FDFBF7]/90 backdrop-blur-xl border-b border-[#2C1E16]/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("inici")}
          className="flex flex-col items-start leading-none"
        >
          <span
            className={`font-display italic text-2xl sm:text-3xl font-bold tracking-tight transition-colors ${
              scrolled ? "text-[#8B0000]" : "text-[#FDFBF7]"
            }`}
            style={{ color: scrolled ? "#8B0000" : "#FDFBF7" }}
          >
            Solís
          </span>
          <span
            className={`text-[0.6rem] uppercase tracking-[0.35em] font-semibold mt-0.5 ${
              scrolled ? "text-[#C8A24A]" : "text-[#E9D7A8]"
            }`}
          >
            Pastisseria
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className={`text-sm font-medium transition-colors hover:opacity-70 ${
                scrolled ? "text-[#2C1E16]" : "text-[#FDFBF7]"
              }`}
            >
              {n.label}
            </button>
          ))}
          <a
            data-testid="nav-call-btn"
            href={`tel:${BUSINESS.phoneTel}`}
            className="rounded-full bg-[#8B0000] text-[#FDFBF7] px-5 py-2 text-sm font-semibold hover:-translate-y-0.5 hover:shadow-lg transition-all"
          >
            {BUSINESS.phoneDisplay}
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className={`lg:hidden ${scrolled ? "text-[#2C1E16]" : "text-[#FDFBF7]"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menú"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden mt-3 mx-4 rounded-2xl bg-[#FDFBF7] shadow-xl border border-[#2C1E16]/10 p-4 flex flex-col"
        >
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-mobile-${n.id}`}
              onClick={() => go(n.id)}
              className="text-left py-3 px-2 text-[#2C1E16] font-medium border-b border-[#2C1E16]/5 last:border-0"
            >
              {n.label}
            </button>
          ))}
          <a
            href={`tel:${BUSINESS.phoneTel}`}
            className="mt-3 text-center rounded-full bg-[#8B0000] text-[#FDFBF7] px-5 py-3 font-semibold"
          >
            Trucar · {BUSINESS.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};
